<template>
	<div class="page-main">
		<div class="page-head">
			<nav-bar title="确认支付" :border="false" :left-arrow="true" @click-left="pageBack"></nav-bar>

			<div class="store-wrap">
				<div class="store-info">
					<div class="left">
						<div class="label">
							<span class="icon"></span>
							<span>自取门店</span>
						</div>
						<div class="store-name text-ellipsis">{{ store.name }}</div>
						<div class="store-address text-ellipsis">{{ store.address }}</div>
					</div>
					<div class="right">
						<div class="title">预计准备时间</div>
						<div class="text">2-5 分钟</div>
					</div>
				</div>
				<div class="time-row" v-if="qcTime">
					<img class="icon" src="~@/assets/icon2.png" />
					{{ timeStr }}
				</div>
				<div class="time-row" v-else>
					<img class="icon" src="~@/assets/icon1.png" />
					即刻取单
				</div>
			</div>
		</div>

		<div class="page-body" ref="scrollDom">
			<div>
				<div class="page-card cart-list" v-if="shoppingCart">
					<div class="title-row">我的订单</div>
					<div class="cart-item" v-for="(item, index) in shoppingCart['Shopping_Cart']" :key="index">
						<div class="goods-img">
							<img :src="item['default_image']" alt="" />
						</div>

						<div class="goods-content">
							<div class="goods-name">{{ item["name"] }}</div>
							<div class="goods-foot">
								<div class="price">￥{{ item["price"] / 100 }}</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 卡券 -->
				<div class="page-card coupons-box">
					<!-- <div class="title-row">使用星享好礼券</div> -->
					<!-- <div @click="showCoupons" class="no-coupons">
        暂无可用礼券
      </div> -->
					<div class="title">好礼星星&星享好礼券</div>
					<div class="coupons-content">
						<div class="left" @click="isStarShow = true">
							<img class="icon" src="~@/assets/icon_gold_star.png" />
							<div class="text">
								<div>使用好礼星星</div>
								<p v-if="starNum > 0">已使用{{ starNum }}星星</p>
								<p v-else>未使用星星</p>
							</div>
						</div>
						<div class="right" @click="isCouponShow = true">
							<div class="text">
								<div>使用星享好礼券</div>
								<p v-if="coupons.length == 0">暂无可用礼券</p>
								<p v-else-if="couponActive">已使用{{couponActive.length}}张礼券</p>
								<p v-else>未使用礼券</p>
							</div>
							<img class="icon" src="~@/assets/order_icon_coupons.png" />
						</div>
					</div>
				</div>






				<!-- 附加选项 -->
				<div class="page-card" v-if="moneyLines">
					<div class="title-row">附加选项</div>
					<div class="package-wrap">

						<div>
							是否需要打包
							<checkbox class="fr" v-model="needPackage" :name="true" checked-color="#00af66" />
						</div>
						<div v-show="isgift">
							使用生日星有礼
							<checkbox class="fr" v-model="isbirthdaygift" :name="true" checked-color="#00af66"
								@change="sendApply" />
						</div>

						<p>
							如需餐具,可联系店内咖啡师获得协助
							<img src="~@/assets/icon3.png" />
						</p>
						<div class="input-group">
							<input v-model="uname" class="input" placeholder="请输入姓名" />
						</div>
					</div>
				</div>
				<div class="page-card Srkit" v-if="Srkit.name !== undefined "> <!-- v-show="paycard"-->

					<img :src="Srkit.tagImage" style="width: 100px; height: auto;">


					<div class="Srkit-container">
						<div v-html="processedData"></div>
					</div>
					<div class="Srkit-container">
						<div class="Srkit-row">
							<p v-for="(item, index) in Srkit.coupons" :key="index" class="paragraph">
								<img :src="item.image" style="width: 100px; height:auto;">
								<span class="coupon-text">X{{ item.count}}</span>
							</p>
							<div class="right-section">
								<span class="coupon-price">￥{{SrkitInfo["price"]/100}}元</span>
								<checkbox class="checkbox-wrapper" v-model="SrkitInfo.choose" :name="true"
									checked-color="#1f623f" @change="sendApply" />
							</div>
						</div>
					</div>
					<div class="description-container">
						<div class="description">{{Srkit.operationContent}}</div>

					</div>




				</div>







				<div class="page-card" v-if="moneyLines">
					<div class="title-row">订单明细</div>

					<div class="pay-method">
						<div @click="payment_method=1">
							<img class="icon" src="~@/assets/zfb.png" />
							<span class="text">
								支付宝
							</span>
							<radio v-model="payment_method" :name="1" checked-color="#00af66"></radio>
						</div>
					</div>

					<div class="dtl-list">
						<div class="dtl-item">
							<div class="name">产品小计</div>
							<div class="line"></div>
							<div class="money">
								￥{{ moneyLines["amount_before_discount"] / 100 }}
							</div>
						</div>
						<div class="dtl-item green" v-if="moneyLines['star_discount_amount'] > 0">
							<div class="name">星星折扣</div>
							<div class="line"></div>
							<div class="money">
								￥{{ moneyLines["star_discount_amount"] / 100 }}
							</div>
						</div>
						<div class="dtl-item green" v-if="moneyLines['coupon_discount_amount'] > 0">
							<div class="name">优惠券折扣</div>
							<div class="line"></div>
							<div class="money">
								￥{{ moneyLines["coupon_discount_amount"] / 100 }}
							</div>
						</div>
						<div class="dtl-item total">
							<div class="name">总计</div>
							<div class="line"></div>
							<div class="money">
								￥{{ moneyLines["amount_after_discount"] / 100 }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="page-foot">
			<div class="left">
				实付:<span v-if="moneyLines">￥{{ moneyLines["amount_after_discount"] / 100 }}</span>
			</div>
			<div class="right-btn" @click="sendSubmit">支付</div>
		</div>

		<popup get-container="body" position="bottom" v-model="isCouponShow" style="height: 80%"
			@close="isCouponShow = false">
			<coupon @couponCb="couponCb" :data="coupons" :active="couponActive" v-if="isCouponShow" />
		</popup>

		<popup get-container="body" position="bottom" v-model="isStarShow" style="height: 80%"
			@close="isStarShow = false">
			<star :data="starOptions" @starCb="starCb" v-if="isStarShow" />
		</popup>
	</div>
</template>

<script>
	import BScroll from "@better-scroll/core";
	import MouseWheel from "@better-scroll/mouse-wheel";
	import coupon from "./proup/index";

	BScroll.use(MouseWheel);
	import {
		navBar,
		popup,
		checkbox,
		radio
	} from "vant";
	import {
		mapGetters
	} from "vuex";
	import star from "./proup/star";
	import {
		getReview,
		getSrkit,
		sendApply,
		sendSubmit
	} from "@/api";
	import store from "@/store";

	export default {
		data() {
			return {
				uname: "",
				needPackage: false,
				IsSrkit: false,
				payment_method: 1,
				qcTime: false,
				timeStr: "",
				sku: "",
				SrkitInfo: "",
				Srkit: "",
				cardprice: 0,
				cardname: "",
				processedData: '',

				isCouponShow: false,
				isStarShow: false,

				starOptions: [],
				coupons: [], //这个暂时不知道是什么可能是可用优惠券吧
				orderLines: [],
				gifts: [],
				isgift: false,
				isbirthdaygift: false,
				usedGifts: [],


				starActive: [],
				couponActive: [],

				moneyLines: null,
				cache: null,


				paycard: store.getters.getpaycard,


			};
		},


		async created() {
			this.qcTime = this.$route.query.time;
			this.timeStr = this.$route.query.timeStr;










			//await this.$store.dispatch("getShoppingCart");
			await this.getReview();
			//await this.sendApply();

			this.$nextTick(() => {
				this.leftScroll = BScroll(this.$refs["scrollDom"], {
					click: true,
					mouseWheel: true,
				});
			});		},



		computed: {
			...mapGetters({
				shoppingCart: "getShoppingCart",
				store: "getStore",
			}),
			starNum() {
				var num = 0;
				for (var item of this.starActive) {
					num += parseInt(item["star_unit"] || 0);
				}
				return num;
			},
		},
		watch: {

			couponActive: {
				deep: true,
				handler() {
					this.sendApply();
				},
			},

			starActive: {
				deep: true,
				handler() {
					this.sendApply();
				},
			},
		},
		methods: {
			//獲取訂單謝謝
			getReview() {
				return getReview(this.qcTime, this.shoppingCart.cache).then((d) => {
					this.coupons = d.data["coupons"];

					//this.orderLines = d.data['order_lines'];
					this.starOptions = d.data["star_options"];

					this.cache = d.data["cache"];




					this.moneyLines = {
						amount_after_discount: d.data["amount_after_discount"],
						amount_before_discount: d.data["amount_before_discount"],
						coupon_discount_amount: d.data["coupon_discount_amount"],
						star_discount_amount: d.data["star_discount_amount"],
					};


					this.Srkit = d.data["Srkit"];

					this.SrkitInfo = {
						"price": this.Srkit["price"],
						"sku": this.Srkit["sku"],
						"poskey": this.Srkit["poskey"],
						"number": 1,
						"choose": this.Srkit["choose"],
						"name": this.Srkit["name"],
						"salesType": this.Srkit["salesType"]
					}



					this.processedData = this.Srkit["description"];
					
					
					this.gifts=d.data["gifts"];




					if (d.data.gifts && d.data.gifts[0] && d.data.gifts[0].usedGiftType === 1) {
						this.isgift = true;
					}






				});
			},
			// 优惠券回调
			couponCb(codes) {
				this.isCouponShow = false;
				this.couponActive = codes;

				console.log(this.couponActive, "回调");


			},
			starCb(v) {
				this.isStarShow = false;
				this.starActive = v;
			},
			getSrkit() {
				return getSrkit().then((d) => {


					this.sku = d.data["sku"];


					this.cardname = d.data["name"];
					this.cardprice = d.data["price"] / 100;






				});
			},





			sendApply() {

				if (this.isbirthdaygift) {
					this.usedGifts = [{
						"usedGiftType": 1
					}, {
						"usedGiftType": 2
					}]
				} else {

					this.usedGifts = [{
						"usedGiftType": 2
					}]
				}





				return sendApply(
					this.cache,
					this.couponActive,
					this.starActive,
					this.orderLines,

					this.SrkitInfo,
					this.usedGifts


				).then((d) => {
					this.cache = d.data["cache"];
					this.coupons = d.data["coupons"];
					this.moneyLines = {
						amount_after_discount: d.data["amount_after_discount"],
						amount_before_discount: d.data["amount_before_discount"],
						coupon_discount_amount: d.data["coupon_discount_amount"],
						star_discount_amount: d.data["star_discount_amount"],
					};
					if (d.data["amount_after_discount"] / 100 === 0) {
						this.payment_method = 7

					} else {
						if (this.payment_method === 7) {
							this.payment_method = 1
						}

					}

					this.gifts = d.data["gifts"];


				});
			},
			pageBack() {
				window.history.back();
			},
			sendSubmit() {

				sendSubmit(this.cache, this.couponActive, this.starActive, this.orderLines, this.uname, this.qcTime, this
					.payment_method, this.needPackage ? 1 : 0, this.SrkitInfo, this.gifts, {




					}).then((d) => {


					store.commit('setorderId', d.data.orderId);



					if (this.payment_method === 1) {
						this.$router.replace({
							name: 'pay',
							query: {
								data: JSON.stringify(d.data)
							}
						})
					}
					if (this.payment_method === 2) {

						location.href = d.data.content;
					}

					if (this.payment_method === 7 || this.moneyLines["amount_after_discount"] / 100 === 0) {
						this.$router.replace({
							name: 'history'
						})
						this.$msg("下单成功");
					}

					//     console.log(d.data.alipay);

					//     //location.href="alipays://platformapi/startapp?appId=20000067&url="+encodeURIComponent(d.data.alipay); //拉起支付宝支付,不支持微信,pc

					//     //   location.href = d.data.alipay;
				});
			},
		},
		components: {
			radio,
			checkbox,
			star,
			navBar,
			popup,
			coupon,
		},
	};
</script>

<style lang="scss" scoped>
	.Srkit-container {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		width: 100%;
	}


	.Srkit-row {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;


	}

	.paragraph {
		display: flex;
		align-items: center;
	}

	.coupon-text {
		margin-left: 5px;
		font-weight: bold;
	}

	.right-section {
		display: flex;
		align-items: center;

	}

	.coupon-price {
		margin-left: auto;
		font-weight: bold;

	}

	.checkbox-wrapper {
		margin-left: auto;

	}

	.description-container {
		display: flex;
		justify-content: center;
		background-color: #f3f0d7;
		width: 100%;
		margin: 1px auto;
		height: 37px;
	}

	.description {
		color: #ff9900;
		font-size: 23px;
		font-weight: normal;
	}


	.page-main {
		background: #f1f1f1;
		height: 100vh;
		display: flex;
		flex-direction: column;

		.page-body {
			flex: 1;
			min-height: 1;
			overflow: hidden;
		}
	}

	.page-head {
		color: #fff;
		background: rgb(40, 40, 40);

		::v-deep .van-nav-bar__content {
			background: rgb(40, 40, 40);
			color: #fff;

			.van-nav-bar__title,
			.van-icon {
				color: #fff;
			}
		}
	}

	.store-wrap {
		padding: 20px 30px;

		.time-row {
			margin-top: 20px;
			line-height: 60px;
			font-size: 28px;

			.icon {
				float: left;
				height: 60px;
				width: 60px;
				margin-right: 20px;
			}
		}
	}

	.store-info {
		border-bottom: 1px solid rgba(255, 255, 255, 0.2);
		padding-bottom: 10px;
		position: relative;
		display: flex;
		align-items: center;

		.left {
			flex: 1;
			min-width: 0;

			.label {
				color: #999;
				font-size: 24px;

				.icon {
					background-image: url(~@/assets/order_icon_map.png);
					background-repeat: no-repeat;
					background-size: contain;
					background-position: center;
					width: 24px;
					height: 26px;
					display: inline-block;
					margin-right: 6px;
				}
			}

			.store-name {
				font-size: 28px;
			}

			.store-address {
				font-size: 24px;
				transform: scale(0.83);
				transform-origin: left;
			}
		}

		.right {
			text-align: right;

			.title {
				color: #999;
				font-size: 24px;
			}

			.text {
				font-size: 28px;
			}
		}

		&::after {
			content: "";
			position: absolute;
			right: 230px;
			top: 30px;
			bottom: 30px;
			width: 1px;
			background: rgba(255, 255, 255, 0.2);
		}
	}

	.page-card {
		margin: 24px;
		padding: 0 20px 20px 20px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
		border-radius: 8px;
		background: #fff;

		.title-row {
			font-size: 28px;
			height: 88px;
			line-height: 88px;
			border-bottom: 1px solid #f1f1f1;
			font-weight: bold;
		}
	}

	.cart-list {
		.cart-item {
			display: flex;
			align-items: center;
			padding: 20px 0;

			.goods-img {
				width: 100px;
				height: 100px;
				border-radius: 50%;
				margin-right: 30px;
				position: relative;

				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					display: block;
					z-index: 5;
					object-fit: contain;
				}

				&::after {
					content: "";
					position: absolute;
					left: 50%;
					top: 50%;
					width: 80px;
					height: 80px;
					background: #d8db3c;
					border-radius: 50%;
					z-index: 1;
					transform: translate(-50%, -50%);
				}
			}

			.goods-content {
				flex: 1;

				.goods-name {
					font-size: 30px;
					font-weight: bold;
				}

				.goods-foot {
					display: flex;
					align-items: center;

					.price {
						flex: 1;
						font-weight: bold;
					}

					img {
						width: 55px;
						height: 55px;
					}
				}
			}
		}
	}

	.page-foot {
		padding: 16px 30px;

		width: 100%;
		background: #fff;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
		z-index: 50;
		display: flex;
		box-sizing: border-box;
		margin: 0 !important;

		.left {
			flex: 1;
			line-height: 80px;
			font-size: 28px;

			span {
				color: #1f623f;
				font-weight: bold;
				font-size: 32px;
			}
		}

		.right-btn {
			width: 400px;
			height: 80px;
			line-height: 80px;
			text-align: center;
			background: #00af66;
			color: #fff;
			border-radius: 40px;
			font-size: 32px;
			letter-spacing: 2px;
		}
	}

	.dtl-list {
		padding-top: 20px;

		.dtl-item {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			margin-top: 10px;

			&.green {
				color: #00af66;
			}

			&.total {
				font-weight: bold;
				font-size: 1.3em;
			}

			.line {
				margin: 0 20px;
				width: 320px;
				align-items: center;
				border-bottom: 1px dashed #999;
			}

			.money {
				text-align: right;
			}
		}
	}

	.coupons-box {
		position: relative;
		margin-bottom: 60px;

		.title {
			color: #666;
			font-size: 24px;
			line-height: 80px;
			height: 120px;
		}

		.coupons-content {

			.left,
			.right {
				position: absolute;
				top: 70px;
				background-size: 100% 100%;
				width: 354px;
				padding: 20px 20px;
				box-sizing: border-box;
				display: flex;
				align-items: center;

				.icon {
					width: 70px;
					height: 50px;
					object-fit: contain;
					margin: 0 10px;
				}

				.text {
					div {
						font-weight: bold;
						font-size: 24px;
					}

					p {
						margin: 0;
						font-size: 24px;
						transform: scale(0.84);
						color: #999;
					}
				}
			}

			.left {
				left: 10px;
				background-image: url(~@/assets/star_card.png);

				p {
					transform-origin: left;
				}
			}

			.right {
				right: 10px;
				text-align: right;
				background-image: url(~@/assets/rewards_card.png);
				justify-content: flex-end;

				p {
					transform-origin: right;
				}
			}
		}
	}

	.package-wrap {
		padding: 20px 30px 0;

		.input-group {
			.input {
				border: 1px solid #f1f1f1;
				line-height: 60px;
				width: 100%;
				padding: 0 30px;
				margin-top: 10px;
				border-radius: 8px;
				box-sizing: border-box;
				font-weight: 400;
			}
		}

		div {
			font-size: 26px;
			line-height: 50px;
			margin-bottom: 20px;
			font-weight: bold;
		}

		p {
			margin: 0;

			img {
				width: 30px;
				height: 30px;
				vertical-align: middle;
			}
		}
	}

	.pay-method {
		padding-left: 70px;

		&>div {
			display: flex;
			border-bottom: 1px solid #f1f1f1;
			align-items: center;
			padding: 16px 0;
		}

		.text {
			flex: 1
		}

		.icon {
			width: 50px;
			height: 50px;
			object-fit: contain;
			margin-right: 20px;
		}
	}

	.no-coupons {
		text-align: center;
		line-height: 88px;
	}
</style>